import { defineMessages } from "react-intl";

import {
	childClassificationMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/childPughClassification";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	childPughClassification: {
		id: "form.childPughClassification",
		defaultMessage: "CHILD"
	},
	childClassification: {
		id: "form.childPughClassification.childClassification",
		defaultMessage: "CHILD–PUGH osztályozás"
	}
});

const fields: { [key: string]: FieldData } = {
	childClassification: {
		type: "field",
		path: ["childClassification"],
		label: messages.childClassification,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: childClassificationMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.childClassification }] }]
};

export const node: LeafNode = {
	id: "childPughClassification",
	value: {
		title: messages.childPughClassification,
		validator,
		fieldset,
		isImportant: false
	}
};
